import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { ActivatedRoute, Router } from '@angular/router';
import { Utils } from '../../util';

import { RemissionService, ProductionOrder, Box, RemissionId } from '../../services/remission.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { FiscalDataService, FiscalData } from '../../services/fiscal-data.service';
import { AddressService } from '../../services/address.service';
import { ProductionOrderService, ProductionOrderData, ProductionOrderId } from '../../services/production-order.service';

import { ISubscription, Subscription } from "rxjs/Subscription";
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { CompanyService, Company, CompanyData } from '../../services/company.service';
import { Globals } from '../../globals';
import { AuthService } from '../../services/auth.service';
import { PermissionService } from '../../services/permission.service';
import { UserService } from '../../services/user.service';
import { FirestoreService } from '../../services/firestore/firestore.service';
import { CustomerBillId } from '../../services/customer-bill.service';
import { PrVntaData, PrVntaId } from '../../services/product-vnta.service';
import { AutoService, FsAuto } from '../../services/auto.service';
import { EmployeeId } from '../../services/employee.service';
import { PdfTemplates } from '../../pdfTemplates';

@Component({
  selector: 'app-display-remission',
  templateUrl: './display-remission.component.html',
  styleUrls: ['./display-remission.component.css']
})
export class DisplayRemissionComponent implements OnInit, OnDestroy {
  permission: any = {};

  userHistory: any[] = [];

  remissionId: string;
  customerName: string = '';

  remission: any = {};
  company: Company = {} as Company;
  isoDescription: any = {};
  address: any = {};

  form: FormGroup;
  
  fiscalData: any = {};
  fiscalDataName
  addressName: string = '-';

  remittedQuantity: number = 0;
  productionOrder: ProductionOrder = {
    id: '',
    folio: '-',
    quantity: 0,
    prClientCode: '-',
    prClientVersion: '-',
    prClientBarCode: '-',
    customerPurchaseOrderNumber: '-',
  };

  subs = [];

  remInputObj = {
    autoName: {key: 'autoName', label: 'Auto', type: 'text', value: ''},
    driverEmployeeName: {key: 'driverEmployeeName', label: 'Chofer', type: 'text', value: ''},
    distanceTraveledKm: {key: 'distanceTraveledKm', label: 'Distancia Recorrida Km', type: 'number', value: 0},
    dateArrival: {key: 'dateArrival', label: 'Fecha llegada', type: 'date', value: Utils.today},
    timeArrival: {key: 'timeArrival', label: 'Hora llegada', type: 'time', value: `01:00PM`},
    weightBoxesKg: {key: 'weightBoxesKg', label: 'Peso Cajas Kg', type: 'number', value: 0},
    license: {key: 'license', label: 'Licencia', type: 'text', value: ''},
    permitSCT: {key: 'permitSCT', label: 'Permiso SCT', type: 'text', value: ''},
  };
  get remInputs(){ return Object.values(this.remInputObj); }

  constructor(
    private service: RemissionService,
    private customerService: CustomerSupplierService,
    private fiscalDataService: FiscalDataService,
    private addressService: AddressService,
    private productionOrderService: ProductionOrderService,
    private settings: CatalogsSettingsService,
    private companyService: CompanyService,
    private companyData: CompanyData,
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
		private permissionService: PermissionService,
    private authService: AuthService,
    private firestoreService: FirestoreService,
    private prVntaData: PrVntaData,
    private autoService: AutoService,
    private fsService: FirestoreService,
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, 'SPECIAL');
    });

    this.remissionId = this.activatedRoute.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.createForm();
    console.log(11);
    this.subs[0] = this.service.getRemission(this.remissionId).subscribe(([remission]) => {
      this.onInit(remission);
      this.remission = remission;
      let { userHistory=[{name:'Desconocido',date:'Desconocida'}], customerObj: {name: customerName} ,fiscalDataObj, addressObj: {countryId,stateId,...address}, productionOrder, boxs, ...formRemission } = remission;
      this.form.patchValue(formRemission);
      console.log(12);
      this.userHistory = userHistory;
      //this.userHistory.map(u => { if(u.id){ let sub = this.userService.getUser(u.id).subscribe(({name, lastName}) => {sub.unsubscribe(); u.name = `${name} ${lastName}`}) } });
      this.address = {
        country: (Globals.COUNTRIES[countryId] || {}).clave || 'MX',
        state: (Globals.STATES[stateId] || {}).clave || 'DIF',
        ...address,
        zipCode: Utils.String.fillLeft(`${address.zipCode}`, '0', 5),
      }
      //if(this.subs[1]) this.subs[1].unsubscribe();
      //this.subs[1] = this.customerService.getCustomerSupplier(customerId).subscribe(c => { this.customerName = c.name });
      this.customerName = customerName;
      let { municipality, neighborhood, postCode, stateId: fStateId, street, countryId: fCountryId, externalNumber, internalNumber, businessName, rfc } = <FiscalData>fiscalDataObj;
      this.fiscalData = { municipality, neighborhood, postCode, state: Globals.STATES[fStateId].name, street, country: Globals.COUNTRIES[fCountryId].name, externalNumber, internalNumber, businessName, rfc };
      this.fiscalDataName = businessName;
      this.addressName = `${address.street}, #${address.externalNumber}`;
      this.productionOrder = productionOrder;
      let sub = this.productionOrderService.getProductionOrder(productionOrder.id).subscribe(([productionOrder]) => {
        sub.unsubscribe();
        this.odp = productionOrder;
        this.remittedQuantity = productionOrder.remittedQuantity;
        if(remission.qualityCertificate){
          remission.qualityCertificate.section = productionOrder.sections.find(({name}) => name == remission.qualityCertificate.odpSection);
        }
        let {prClient: { code='-', version='-', barCode='-' }} = productionOrder;
        //this.productionOrder.prClientCode = code;
        //this.productionOrder.prClientVersion = version;
        this.productionOrder.prClientBarCode = barCode;
        this.getProductionOrderProduct(productionOrder.prVntaId);
      });
      this.boxs = boxs;
      for(let key in this.remInputObj) this.remInputObj[key].value = remission[key] != undefined ? remission[key] : '';
    });
    
    let companySub = this.companyService.getCompany().subscribe(company => {
      companySub.unsubscribe();
      this.company = company;
    });

    let setSub = this.settings.getPayrollSettings('1').subscribe(({isoDescriptions: {Rem, Etiq, CrtCal}}) => {
      setSub.unsubscribe();
      [ this.isoDescription.rem, this.isoDescription.etiq, this.isoDescription.crtcal ] = [Rem, Etiq, CrtCal];
    });
  }
	ngOnDestroy() {
    this.subs.map((sub, index) => {
      this.subs[index].unsubscribe();
    });
  }
  async onInit(rem: RemissionId){
    if(rem.autoId){
      let autos = await this.autoService.getAutos();
      let auto = autos.find(auto => auto.id == rem.autoId);
      this.remInputObj.autoName.value = auto ? `${auto.model}, ${auto.placa}` : '';
    }
    if(rem.driverEmployeeId){
      let employee = await this.fsService.docWithId<EmployeeId>(`${Globals.EMPLOYEE_COLLECTION}/${rem.driverEmployeeId}`);
      this.remInputObj.driverEmployeeName.value = employee ? `${employee.name} ${employee.lastName}` : '';
    }
  }

  createForm(){
    this.form = this.fb.group({
      folio: '',
      date: '',
      quantity: '',
      description: '',
      notesEtiq: ''
    });
  }

  odpPrVnta: PrVntaId;
  async getProductionOrderProduct(prVntaId: string){
    let odpPrVnta: PrVntaId = await this.firestoreService.docWithId(`${Globals.PRVNTA_COLLECTION}/${prVntaId}`) as PrVntaId;
    for(let i = 0; i < odpPrVnta.characs.length; i++) delete odpPrVnta.characs[i].unitId;
    delete odpPrVnta.classnId;
    this.odpPrVnta = odpPrVnta;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////BOXS
  boxs: Box[] = [];
  get boxsTotal(): number {
    return this.boxs.reduce((total, {amount, pieces}) => total + amount*pieces, 0);
  }
  //////////////////////////////////////////////////////////////////////////////////////////////BOXS

  onBack(){
    let url = localStorage.remBack || '/remission';
    delete localStorage.remBack;
    this.router.navigate([url])
  }


  onPdf({isRem}){
    //if(1) return toast('No está listo este servicio.');
    console.log(JSON.parse(this.pdfJson));
    window[ isRem ? 'sendRemissionToPhp' : 'sendRemissionEtiquetasToPhp' ](false);
  }

  

  odp: ProductionOrderId;
  timbrarPdf: string = '';
  get timbrarPdfObj(){
    return this.remission ? {
      remId: this.remissionId,
      customerName: this.customerName,
      fiscalDataName: this.fiscalData.businessName,
      fiscalData: this.fiscalData,
      address: this.address,
      addressLocality: Globals.LOCALITYS[this.address.xlocality || 'Aguascalientes'].locality,
      addressMunicipality: Globals.MUNICIPALITYS[this.address.xmunicipality || 'Aguascalientes'].municipality,
      productionOrderFolio: this.productionOrder.folio,
      productionOrderQuantity: this.productionOrder.quantity,
      odp: this.productionOrder,
      odpPrecioUnitario: this.odp.pricePerUnit,
      valorMercancia: this.odp.pricePerUnit*this.remission.quantity,
      remittedQuantity: this.remittedQuantity,
      folio: `REMS-${this.remission.folio}`,
      date: this.remission.date,
      quantity: this.remission.quantity,
      description: this.remission.description,
      notesEtiq: this.remission.notesEtiq,
      boxs: this.boxs,
      qualityCertificate: this.remission.qualityCertificate,
      fields: [
        {key: 'distanceTraveledKm', label: 'Distancia Recorrida Km', type: 'number', value: this.remission.distanceTraveledKm || 0},
        {key: 'dateArrival', label: 'Fecha llegada', type: 'date', value: this.remission.dateArrival || Utils.today},
        {key: 'timeArrival', label: 'Hora llegada', type: 'time', value: `${Utils.transformTimeStrTo24Format(this.remission.timeArrival || `01:00PM`)}:00`},
        {key: 'weightBoxesKg', label: 'Peso Cajas Kg', type: 'number', value: this.remission.weightBoxesKg || 0},
        {key: 'license', label: 'Licencia', type: 'text', value: this.remission.license || ''},
        {key: 'permitSCT', label: 'Permiso SCT', type: 'text', value: this.remission.permitSCT || ''},
      ],
      fechaHoraLlegada: `${this.remission.dateArrival || Utils.today}T${Utils.transformTimeStrTo24Format(this.remission.timeArrival || `01:00PM`)}:00`,

      companyImgUrl: this.company.imageURL,
      companyName: this.company.name,
      companyFiscalName: this.company.socialReason,
      companySatPrivateKey: this.company.satPrivateKey,
      companyState: (Globals.STATES[this.company.state] || {clave: 'DIF'}).clave,
      companyCountry: (Globals.COUNTRIES[this.company.country] || {clave: 'MEX'}).clave,
      companyCities: `${this.company.municipality}, ${this.company.city}`,
      companyAddress: this.company.street + ' ' + this.company.numExt + this.company.numInt + '&emsp;' + this.company.colony + '&emsp;' + this.company.municipality + '&emsp;' + this.company.city + '&emsp;C.P. ' + this.company.postCode,
      companyPhone: this.company.phoneOne,
      companyEmail: this.company.email,
      companyWebPage: this.company.webPage || '',
      companyFiles: this.company.files,
      companyRfc: this.company.RFC,
      companyFiscalRegimen: this.companyData.fiscalRegimenSelect[this.company.fiscalRegimen || 'key0'].full,
      companyZipCode: Utils.String.fillLeft(this.company.postCode, '0', 5),

      prVntaProductSatKey: `${this.odpPrVnta.productSatKey}, ${this.prVntaData.productSatKeyObjects[this.odpPrVnta.productSatKey].description}`,
      prVntaUnitSatKey: `${this.odpPrVnta.unitSatKey}, ${this.prVntaData.unitSatKeyObjects[this.odpPrVnta.unitSatKey].description}`,
      prVntaDescription: this.odpPrVnta.description,
      //prVnta: this.odpPrVnta,

      isoDescriptionRem: this.isoDescription.rem,
      isoDescriptionEtiq: this.isoDescription.etiq,
      isoDescriptionCrtCal: this.isoDescription.crtcal

    } : {fields: []};
  }
  async onTimbrarPdf(){
    if(!this.remission.dateArrival || !this.remission.timeArrival) return toast('Falta fecha u hora de llegada.', 3000);
    let auto: FsAuto = (await this.autoService.getAutos()).find(auto => auto.id == this.remission.autoId) || {} as FsAuto;
    let driver: EmployeeId = this.remission.driverEmployeeId ? await this.firestoreService.docWithId<EmployeeId>(`${Globals.EMPLOYEE_COLLECTION}/${this.remission.driverEmployeeId}`) : null;
    this.timbrarPdf = JSON.stringify({ ...this.timbrarPdfObj, auto, driverName: driver ? `${driver.name} ${driver.lastName}` : '' });
    let keyWhitelist = ['isoDescriptionRem', 'isoDescriptionEtiq', 'isoDescriptionCrtCal', 'notesEtiq', 'qualityCertificate'];
    for(let key in this.timbrarPdfObj) if(!this.timbrarPdfObj[key] && !keyWhitelist.includes(key)) return toast('Faltan datos.', 2000);
    for(let field of this.timbrarPdfObj.fields) if(!field.value) return toast('Faltan datos.', 2000);
    //if(1) return console.log(this.timbrarPdfObj);

    setTimeout(window['sendRemissionTimbradoToPhp'], 1000, false);
    console.log(this.timbrarPdf);
  }
  async onRemPdf(){
    if(!this.address.requiresCartaPorte) return toast('No Requiere Carta Porte además del CFDI de Traslado en dirección.', 3000);
    let pdf = PdfTemplates.Reports.RemPdf(this.remission);
    console.log(pdf);
  }
  async openUrl(url: string){
    let a = document.createElement('a');
    a.target = '_blank';
    a.href = url;
    document.appendChild(a);
    a.click();
    document.removeChild(a);
  }
  /* onCertificate(){
    if(!this.permission.qualityCertificate) return toast('Necesita permisos especiales para certificado de calidad.', 2000);
    if(!this.remission.qualityCertificate || this.remission.qualityCertificate.status != 'key2') return toast('El certificado de calidad no está aprobado.', 2000);
    window['sendQualityCertificate'](false);
  } */
  async onSetFree(){
    if(!this.permission.remissionSetFree) return toast('No tiene permisos para esta acción.', 2000);
    let userIsSure = confirm('¿Liberar la remisisón de la factura? Esta acción NO es reversible.');
    if(!userIsSure) return;
    let billIds = [...this.remission.billRefs];
    await this.service.updateByField({billQuantitys: [], billRefs: [], status: 0}, this.remissionId);
    console.log('DISPLAY_REMISSION.onSetFree()', `cleared rem of id: '${this.remissionId}'`);
    for(let billId of billIds){
      let billDoc = await this.firestoreService.docWithId<CustomerBillId>(`${Globals.CUSTOMER_BILL_COLLECTION}/${billId}`);
      if(!billDoc) return;
      for(let pr of billDoc.prForBills) if(pr.remissionId == this.remissionId) pr.remissionId = '';
      await this.firestoreService.update(`${Globals.CUSTOMER_BILL_COLLECTION}/${billId}`, {prForBills: billDoc.prForBills});
      console.log('DISPLAY_REMISSION.onSetFree()', `cleared bill of id: '${billId}'`);
    }
  }

  get pdfJson(){
    return this.remission ? JSON.stringify({
      customerName: this.customerName,
      fiscalDataName: this.fiscalData.businessName,
      fiscalData: this.fiscalData,
      address: this.address,
      productionOrderFolio: this.productionOrder.folio,
      productionOrderQuantity: this.productionOrder.quantity,
      ...this.productionOrder,
      remittedQuantity: this.remittedQuantity,
      folio: `REMS-${this.remission.folio}`,
      date: this.remission.date,
      quantity: this.remission.quantity,
      description: this.remission.description,
      notesEtiq: this.remission.notesEtiq,
      boxs: this.boxs,
      qualityCertificate: this.remission.qualityCertificate,

      companyImgUrl: this.company.imageURL,
      companyName: this.company.name,
      companyCities: `${this.company.municipality}, ${this.company.city}`,
      companyAddress: this.company.street + ' ' + this.company.numExt + this.company.numInt + '&emsp;' + this.company.colony + '&emsp;' + this.company.municipality + '&emsp;' + this.company.city + '&emsp;C.P. ' + this.company.postCode,
      companyPhone: this.company.phoneOne,
      companyEmail: this.company.email,
      companyWebPage: this.company.webPage || '',

      isoDescriptionRem: this.isoDescription.rem,
      isoDescriptionEtiq: this.isoDescription.etiq,
      isoDescriptionCrtCal: this.isoDescription.crtcal

    }) : '';
  }


}
